const config = {
  ENVIRONMENT_NAME: 'prod',
  forwoodId: {
    URL: 'https://id.eu.forwood.one',
    USER_TOKEN_URL: 'https://hn25cgbj89.execute-api.eu-west-1.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'eu-west-1',
    URL: 'https://qtlf167yfh.execute-api.eu-west-1.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'admin-container-1.11.5',
    HOSTNAME: 'https://admin.eu.forwood.one',
    COMPANY_MICROFRONTEND_URL: 'https://company.eu.forwood.one',
    PHYSICAL_LOCATION_MICROFRONTEND_URL: 'https://locations.eu.forwood.one'
  },
  configurationService: {
    URL: 'https://config.eu.forwood.one',
    WEBSOCKET: 'wss://njlct11lni.execute-api.eu-west-1.amazonaws.com/prod'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
